import React from "react";
import "./golfstatus-organization-tos.scss";
import {
  GSActionBar,
  GSEmptyList,
  GSItemList,
} from "golfstatus_react_components";
import { useDispatch, useSelector } from "react-redux";
import {
  saveOrganization,
  selectCurrentOrganization,
  setSelectedOrganization,
} from "../reducers/organizationSlice";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

import { useIntercom } from "react-use-intercom";
import { selectCurrentUser } from "../reducers/appSlice";
import { hasMemberAccess } from "../helpers/Access";

const GolfstatusOrganizationTOS = (props) => {
  const currentOrg = useSelector(selectCurrentOrganization);
  const currentUser = useSelector(selectCurrentUser);
  const intercom = useIntercom()
  const dispatch = useDispatch();
  const accept = () => {
    let update = { ...currentOrg };
    update.tosAcceptedAt = new Date();
    update.tosAcceptedBy = currentUser.id;
    dispatch(setSelectedOrganization(update))
    dispatch(saveOrganization(update));
  };

  const getTermsOfServiceMessage = () => {
    return (
      <GSEmptyList
        detail={
          <div>
            To utilize GolfStatus, please review and accept the{" "}
            <a target="_blank" rel="noreferrer" href="https://golfstatus.com/golfstatus-terms-of-service">
              Terms of Service
            </a>{" "}
            and{" "}
            <a target="_blank" rel="noreferrer" href="https://golfstatus.com/golfstatus-privacy-policy">
              Privacy Policy
            </a>{" "}
            on behalf of {currentOrg.name}.
          </div>
        }
        actions={[
          {
            title: "Accept & Continue",
            buttonIcon: faCircleCheck,
            onClick: accept,
            type: "green",
          },
        ]}
      />
    );
  };
  const getNoAccessMessage = () => {
    return (
      <GSEmptyList
        detail={
          <div>
            You don’t have permission to accept the{" "}
            <a target="_blank" rel="noreferrer" href="https://golfstatus.com/golfstatus-terms-of-service">
              Terms of Service
            </a>{" "}
            and{" "}
            <a target="_blank" rel="noreferrer" href="https://golfstatus.com/golfstatus-privacy-policy">
              Privacy Policy
            </a>{" "}
            on behalf of {currentOrg.name}.
          </div>
        }
        actions={[
          {
            title: "Contact Support",
            onClick: () => {intercom?.show()},
            type: "light-grey",
          },
        ]}
      />
    );
  };
  return (
    <golfstatus-organization-tos>
      <GSActionBar
        type="form-header"
        header="Terms of Service & Privacy Policy"
      />
      <GSItemList
        type="vertical"
        items={[]}
        listItem={() => ""}
        emptyMessage={hasMemberAccess(currentUser, currentOrg) ? getTermsOfServiceMessage() : getNoAccessMessage() }
      />
    </golfstatus-organization-tos>
  );
};

export default GolfstatusOrganizationTOS;
